import { AxiosRequestConfig } from "axios";
import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";
import { toast } from "react-toastify";

const getProfile = async (
  profileId: string,
  daysToFilter: number
): Promise<any> => {
  try {
    const config: AxiosRequestConfig = {
    };
    const response = await ApiService.get(
      `/dashboard/profile/${profileId}?daysToFilter=${daysToFilter}`,
      config
    );
    const { data, error } = response.data;
    if (error) {
      toast.error("Não foi possível recuperar os dados da conta");
      return null;
    } else {
      return data;
    }
  } catch (error) {
    const { message } = handleError(
      error,
      "Não foi possível carregar os planos."
    );
    toast.error(message);
    return [];
  }
};

export const DashboardService = {
  getProfile,
};
